import styled from 'styled-components'

const StyledWrapper = styled.div`
  margin: 12px 0;

  .ant-card-body {
    text-align: initial;
  }
`

export default StyledWrapper
